/**
 *
 * @param state
 * @returns {[]|*}
 */
export function notification_profiles(state) {
    return state.notification_profiles;
}